<script>
  import Title from '../../assets/general/title.svelte';
  import BigOrangeThing from '../../assets/general/bigOrangeThing.svelte';
</script>

<Title 
  text="Who We Are"
/>

<div class="container">
  <BigOrangeThing
    headerImage="../images/other/FWDCoverBW.jpg"
    alt="Black and white photo of Erin Gruwell and several Freedom Writers"
    title="Our Story"
    text="In 1994, Long Beach was a racially divided community filled with drugs, gang warfare, and homicides, and the tensions on the streets had carried into the school halls. When idealistic first-year teacher Erin Gruwell walked into Room 203 at Wilson High School, her students had already been labeled <q>unteachable.</q> But Gruwell believed in something more..."
    hashID="OurStory"
  />
  <BigOrangeThing
    headerImage="../images/other/EGHeadshot.jpg"
    alt="Photo of Erin Gruwell"
    title="Erin Gruwell"
    text="Erin Gruwell is a teacher, an author, and the founder of the Freedom Writers Foundation. By fostering an educational philosophy that values and promotes diversity, Erin transformed her students' lives. Through the Freedom Writers Foundation, she currently teaches educators around the world how to implement her innovative lesson plans into their own classrooms."
    hashID="ErinGruwell"
  />
  <BigOrangeThing
    headerImage="../images/other/FreedomWritersGroupShot.jpg"
    alt="A group shot of Freedom Writers at a Freedom Writers event."
    title="Freedom Writers"
    text="On their first day of high school, Erin Gruwell's students had only three things in common: they hated school, they hated each other, and they hated her. But all of that changed when they discovered the power of telling their stories. Against all odds, all of 150 of them went on to graduate, become published authors, and start a world-wide movement to change the education system as we know it."
    hashID="FreedomWriters"
  />
</div>

<style>
.container {
  display: flex;
  flex-wrap: wrap; /* Allows items to wrap onto the next line */
  gap: 1.17rem; /* Ensures a minimum gap between components */
  padding: 1rem;
  align-items: center; /* This aligns items vertically in the center */
  justify-content: space-around;

}
@media (max-width: 768px) {
  .container {
    gap: 0.5rem; /* Cut the gap in half for mobile devices */
    padding: 0.5rem;
  }
}
</style>